import { css, styled } from 'styled-components';

const baseStyles = css<{
    color?: string;
    $textAlign?: string;
    $ellipsis?: boolean;
    $breakAnywhere?: boolean;
}>`
    font-family: ${({ theme }) => theme.fontBase};
    color: ${({ color, theme }) => color || theme.textColor};
    font-weight: 600;
    padding: 0;
    margin: 0;
    overflow-wrap: ${({ $breakAnywhere }) => ($breakAnywhere ? 'anywhere' : 'break-word')};
    ${({ $textAlign }) => $textAlign && `text-align: ${$textAlign};`}
    ${({ $ellipsis }) =>
        $ellipsis &&
        `
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    `}
  @media print {
        white-space: nowrap;
    }
`;

export const Headline = styled.h1`
    ${baseStyles}
    font-size: 48px;
    font-weight: 600;
    line-height: 50px;
    letter-spacing: -0.02em;

    @media (max-width: 600px) {
        font-size: 32px;
        line-height: 36px;
        letter-spacing: -0.01em;
    }
`;

export const H1 = styled.h1`
    ${baseStyles}
    font-size: 32px;
    line-height: 111%;

    @media (max-width: 600px) {
        font-size: 24px;
        line-height: 110%;
    }
`;

export const H2 = styled.h2`
    ${baseStyles}
    font-size: 24px;
    line-height: 29px;
    letter-spacing: -0.01em;

    @media (max-width: 600px) {
        font-size: 20px;
        line-height: 25px;
    }
`;

export const H2Medium = styled(H2)`
    font-weight: 500;
`;

export const H3 = styled.h3`
    ${baseStyles}
    font-size: 20px;
    line-height: 24px;

    @media (max-width: 600px) {
        font-size: 18px;
        line-height: 22px;
    }
`;

export const H3Medium = styled(H3)`
    font-weight: 500;
`;

export const H4 = styled.h4`
    ${baseStyles}
    font-size: 16px;
    line-height: 19px;

    @media (max-width: 600px) {
        font-size: 14px;
        line-height: 17px;
    }
`;

export const H4Medium = styled(H4)`
    font-weight: 500;
`;
